import { useDispatch, useSelector } from 'react-redux'
import Fab from '@mui/material/Fab'
import Tooltip from '@mui/material/Tooltip'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'

import { selectActiveBuildingId } from '@/features/building/buildingSlice'
import { openAiAssistant, selectAiAssistantOpen } from './aiAssistantSlice'
import { isAiBuildingAllowed } from './utils'
import AiAssistantDrawer from './AiAssistantDrawer'

const AiAssistantFab = () => {
  const dispatch = useDispatch()
  const buildingId = useSelector(selectActiveBuildingId)
  const isOpen = useSelector(selectAiAssistantOpen)

  if (!isAiBuildingAllowed(buildingId)) {
    return null
  }

  return (
    <>
      <Tooltip title="ИИ-ассистент">
        <Fab
          color="primary"
          aria-label="ai-assistant"
          onClick={() => dispatch(openAiAssistant())}
          sx={{
            position: 'fixed',
            bottom: { xs: 80, md: 24 },
            right: 24,
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <SmartToyOutlinedIcon />
        </Fab>
      </Tooltip>
      <AiAssistantDrawer open={isOpen} />
    </>
  )
}

export default AiAssistantFab
